import React, { useState, useEffect } from 'react';

export const SearchBijlesFilters: React.FC = () => {
  const [eigenLocatieChecked, setEigenLocatieChecked] = useState(true);
  const [schoolLocatieChecked, setSchoolLocatieChecked] = useState(true);

  useEffect(() => {
    // Update elements based on the eigenLocatieChecked state
    const eigenElements = document.querySelectorAll(
      '.list-item--featured, .gm-style img[src="/wp-content/themes/lyceo-2015/images/marker-blue.svg"]'
    );

    eigenElements.forEach(element => {
      const parentDiv = element.closest('.list-item') || element.parentElement as HTMLElement;
      if (parentDiv) {
        if (eigenLocatieChecked) {
          parentDiv['style'].display = 'flex';
        } else {
          parentDiv['style'].display = 'none';
        }
      }
    });

    // If both checkboxes are unchecked, check only the other one
    if (!eigenLocatieChecked && !schoolLocatieChecked) {
      setSchoolLocatieChecked(true);
    }
  }, [eigenLocatieChecked]);

  useEffect(() => {
    // Update elements based on the schoolLocatieChecked state
    const schoolElements = document.querySelectorAll(
      '.list-item:not(.list-item--featured), .gm-style img[src="/wp-content/themes/lyceo-2015/images/marker.svg"]'
    );

    schoolElements.forEach(element => {
      const parentDiv = element.closest('.list-item') || element.parentElement as HTMLElement;
      if (parentDiv) {
        if (schoolLocatieChecked) {
          parentDiv['style'].display = 'flex';
        } else {
          parentDiv['style'].display = 'none';
        }
      }
    });

    // If both checkboxes are unchecked, check only the other one
    if (!schoolLocatieChecked && !eigenLocatieChecked) {
      setEigenLocatieChecked(true);
    }
  }, [schoolLocatieChecked]);

  const handleEigenLocatieChange = (): void => {
    if (eigenLocatieChecked && !schoolLocatieChecked) {
      setSchoolLocatieChecked(true);
    }
    setEigenLocatieChecked(!eigenLocatieChecked);
  };

  const handleSchoolLocatieChange = (): void => {
    if (schoolLocatieChecked && !eigenLocatieChecked) {
      setEigenLocatieChecked(true);
    }
    setSchoolLocatieChecked(!schoolLocatieChecked);
  };

  return (
    <div className="locatie_filter">
      <input
        className="bem-checkbox"
        type="checkbox"
        id="eigenlocatie"
        name="eigenlocatie"
        value="eigen"
        checked={eigenLocatieChecked}
        onChange={handleEigenLocatieChange}
      />
      <label className="bem-checkbox__label" htmlFor="eigenlocatie">
                Eigen locatie
      </label>

      <input
        className="bem-checkbox"
        type="checkbox"
        id="schoollocatie"
        name="schoollocatie"
        value="school"
        checked={schoolLocatieChecked}
        onChange={handleSchoolLocatieChange}
      />
      <label className="bem-checkbox__label" htmlFor="schoollocatie">
                Schoollocatie
      </label>
    </div>
  );
};
